import './Box.scss';
import React from 'react';

const spacingKeys = {
  m: 'margin',
  mt: 'marginTop',
  mr: 'marginRight',
  mb: 'marginBottom',
  ml: 'marginLeft',
  p: 'padding',
  pt: 'paddingTop',
  pr: 'paddingRight',
  pb: 'paddingBottom',
  pl: 'paddingLeft',
};

const toSpacing = (value) => (typeof value === 'number' ? value * 8 : value);

const normalizeSx = (sx) => {
  if (!sx || Array.isArray(sx) || typeof sx !== 'object') {
    return sx;
  }

  return Object.entries(sx).reduce((styles, [key, value]) => {
    if (key.startsWith('&')) {
      return styles;
    }

    styles[spacingKeys[key] || key] = spacingKeys[key] ? toSpacing(value) : value;
    return styles;
  }, {});
};

function Box({
  children,
  component = 'div',
  className = '',
  style,
  sx,
  display,
  flexDirection,
  justifyContent,
  alignItems,
  flexWrap,
  gap,
  width,
  minWidth,
  height,
  mt,
  mb,
  p,
  py,
  item,
  container,
  ...rest
}) {
  const Element = component;
  const boxClassName = ['custom-box', className].filter(Boolean).join(' ');
  const layoutStyle = {
    display,
    flexDirection,
    justifyContent,
    alignItems,
    flexWrap,
    gap: toSpacing(gap),
    width,
    minWidth,
    height,
    marginTop: toSpacing(mt),
    marginBottom: toSpacing(mb),
    padding: toSpacing(p),
    paddingTop: toSpacing(py),
    paddingBottom: toSpacing(py),
  };

  return (
    <Element className={boxClassName} style={{ ...layoutStyle, ...normalizeSx(sx), ...style }} {...rest}>
      {children}
    </Element>
  );
}

export default Box;
